import React from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styled from '@emotion/styled';
import { TagsInput } from '../components/TagsInput';

const PROCEDURE_MODES = [
  { value: 'ia', label: 'IA agenda (padrão)' },
  { value: 'transfer', label: 'Transfere para humano' },
  { value: 'disabled', label: 'Desabilitado' },
];

export function TabGateway({ config, onChange }) {
  const handleChange = (key, value) => {
    onChange({ ...config, [key]: value });
  };

  return (
    <div style={{ fontFamily: "'Poppins', 'Helvetica', sans-serif" }}>
      <SectionTitle>Configurações do Gateway</SectionTitle>

      <Section>
        <SectionHeader><span>Identidade do Bot</span></SectionHeader>
        <SectionBody>
          <Field>
            <Label>Nome do Bot</Label>
            <Hint>Nome que o bot usa nas mensagens. Ex: Evah, BIA</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Evah"
              value={config.botName || ''}
              onChange={(e) => handleChange('botName', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            />
          </Field>

          <Field>
            <Label>Modo Procedimento</Label>
            <Hint>Como o bot trata pedidos de procedimento/exame</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              select
              value={config.procedureMode || 'ia'}
              onChange={(e) => handleChange('procedureMode', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            >
              {PROCEDURE_MODES.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </TextField>
          </Field>

          <Field>
            <FormControlLabel
              control={
                <Switch
                  checked={config.allowThirdParty !== false}
                  onChange={(e) => handleChange('allowThirdParty', e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label={<SwitchLabel>Permitir agendamento para terceiros</SwitchLabel>}
            />
          </Field>
        </SectionBody>
      </Section>

      <Section>
        <SectionHeader><span>Mensagens</span></SectionHeader>
        <SectionBody>
          <Field>
            <Label>Menu Principal</Label>
            <Hint>Texto do menu inicial. Vazio = usa default do template.</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={4}
              placeholder="Deixe vazio para usar o menu padrão"
              value={config.menuPrincipal || ''}
              onChange={(e) => handleChange('menuPrincipal', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            />
          </Field>

          <Field>
            <Label>Fallback Curto</Label>
            <Hint>Mensagem quando o bot não entende (primeira vez)</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder="Deixe vazio para usar o padrão"
              value={config.fallbackCurto || ''}
              onChange={(e) => handleChange('fallbackCurto', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            />
          </Field>

          <Field>
            <Label>Fallback Repetido</Label>
            <Hint>Mensagem quando não entende pela segunda vez</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder="Deixe vazio para usar o padrão"
              value={config.fallbackCurtoRepetido || ''}
              onChange={(e) => handleChange('fallbackCurtoRepetido', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            />
          </Field>

          <Field>
            <Label>Mensagem Transferência Procedimento</Label>
            <Hint>Mensagem ao transferir para humano (quando modo = transfere)</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder="Deixe vazio para usar o padrão"
              value={config.transferProcedureMessage || ''}
              onChange={(e) => handleChange('transferProcedureMessage', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            />
          </Field>
        </SectionBody>
      </Section>

      <Section>
        <SectionHeader><span>Personalização</span></SectionHeader>
        <SectionBody>
          <Field>
            <Label>Nome da Clínica</Label>
            <Hint>Nome usado pelo bot ao se referir à clínica nas mensagens.</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Ex: Clínica Ortopédica SBC"
              value={config.clinicName || ''}
              onChange={(e) => handleChange('clinicName', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            />
          </Field>

          <Field>
            <Label>Saudação Inicial</Label>
            <Hint>Primeira mensagem que o bot envia ao paciente. Vazio = usa saudação padrão do template.</Hint>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={4}
              placeholder="Ex: Olá! Sou a Evah, assistente virtual da clínica. Como posso ajudar?"
              value={config.saudacao || ''}
              onChange={(e) => handleChange('saudacao', e.target.value)}
              inputProps={{ style: { fontSize: 13 } }}
            />
          </Field>

          <Field>
            <FormControlLabel
              control={
                <Switch
                  checked={config.requireTipoConsulta || false}
                  onChange={(e) => handleChange('requireTipoConsulta', e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label={<SwitchLabel>Perguntar tipo de consulta</SwitchLabel>}
            />
            <Hint>Quando ativo, após escolher profissional, pergunta o tipo (Consulta, Retorno, Sessão Fisio, etc).</Hint>
          </Field>
        </SectionBody>
      </Section>

      <Section>
        <SectionHeader><span>Modo Desenvolvimento</span></SectionHeader>
        <SectionBody>
          <Field>
            <FormControlLabel
              control={
                <Switch
                  checked={config.devMode || false}
                  onChange={(e) => handleChange('devMode', e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label={<SwitchLabel>Dev Mode</SwitchLabel>}
            />
            <Hint>Quando ativo, a IA responde APENAS para os números abaixo. Outros números são ignorados silenciosamente. Use para testar sem afetar pacientes reais.</Hint>
          </Field>

          {config.devMode && (
            <Field>
              <Label>Números permitidos</Label>
              <Hint>Números que a IA vai responder em dev mode. Formato: DDD + número (ex: 11999887766).</Hint>
              <TagsInput
                value={config.devModeNumbers || []}
                onChange={(tags) => handleChange('devModeNumbers', tags)}
                placeholder="Digite o número e pressione Enter..."
              />
            </Field>
          )}
        </SectionBody>
      </Section>
    </div>
  );
}

const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
`;

const Section = styled.div`
  background: #fff;
  border: 1px solid #219A97;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
`;

const SectionHeader = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  padding: 8px 16px;
  background: #1b8c89;
  border-bottom: 1px solid #219A97;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const SectionBody = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  input, textarea {
    font-size: 13px !important;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
`;

const Hint = styled.span`
  font-size: 10.5px;
  color: #999;
  line-height: 1.3;
  margin-bottom: 4px;
`;

const SwitchLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
`;
